<template>
  <div class="tw-mb-10 tw-rounded-sm tw-bg-white tw-p-6">
    <div class="tw-mb-4 tw-text-xl tw-font-medium tw-text-primary-grey-700">
      {{ $t("received-headers") }}
    </div>
    <cl-skeleton :loading-text="$t('loading')" v-if="state === 'fetchning'">
      <cl-skeleton-row />
      <cl-skeleton-row :bg="'light'" :width="'lg'" />
      <cl-skeleton-row :width="'sm'" />
      <cl-skeleton-row :bg="'light'" :width="'md'" />
      <cl-skeleton-row :width="'lg'" />
      <cl-skeleton-row :bg="'light'" :width="'sm'" />
    </cl-skeleton>
    <t-empty v-else-if="state === 'error'">
      <template #title>
        {{ $t("subtext-default") }}
      </template>
    </t-empty>
    <div v-else>
      <div
        v-for="(headerData, index) in receivedHeaders"
        :key="headerData.id || index"
      >
        <ul class="tw-mb-4 tw-list-none tw-overflow-x-auto">
          <li
            class="tw-mb-1 tw-text-sm tw-font-normal tw-text-primary-grey-700"
          >
            <span class="tw-capitalize tw-text-primary-grey-300">
              {{ `${headerData.name}: ` }}
            </span>
            <span class="tw-ml-2">{{ headerData.value }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useIsMspRoute } from "@/composables/useIsMspRoute";
import { useGlobalOrganisationIDBasedOnRoute } from "@/composables/useGlobalOrganisationIDBasedOnRoute";
import TEmpty from "@/components/TEmpty/TEmpty.vue";
import { useIncidents } from "../../useIncidents.store";

const { globalOrganisationId } = useGlobalOrganisationIDBasedOnRoute();
const { isMspRoute } = useIsMspRoute();
const state = ref<"fetchning" | "ready" | "error">("fetchning");

const {
  receivedHeaders,
  getReceivedHeaders: fetchReceivedHeaders,
  incidentDetails,
} = useIncidents();

const mailbox = computed(
  () => incidentDetails.value?.message?.receiver || null,
);
const mailSpMessageID = computed(
  () => incidentDetails.value?.mail_sp_message_id || null,
);
const customerGlobalAccountID = computed(() =>
  isMspRoute.value
    ? incidentDetails.value?.customer_global_accountid
    : globalOrganisationId.value,
);

const getReceivedHeaders = async () => {
  if (
    !mailSpMessageID.value ||
    !mailbox.value ||
    !customerGlobalAccountID.value
  ) {
    return (state.value = "error");
  }

  try {
    state.value = "fetchning";

    await fetchReceivedHeaders({
      customerGlobalAccountID: customerGlobalAccountID.value,
      mailbox: mailbox.value,
      mailSpMessageID: mailSpMessageID.value,
    });

    state.value = "ready";
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    state.value = "error";
  }
};

getReceivedHeaders();
</script>
